<template>
  <b-modal id="delete-question-modal" class="confirm-dialog" hide-header centered>
    <p class="modal-main-message">Are you sure you want delete the question?</p>
    <div slot="modal-footer">
      <b-btn
        @disabled="isLoading"
        variant="ghost"
        class="mr-1 btn-cancel"
        @click="$root.$emit('bv::hide::modal', 'delete-question-modal')"
      >
        Cancel
      </b-btn>
      <b-btn
        v-bind:disabled="isLoading"
        variant="primary"
        class="ml-1"
        @click="onDelete"
      >
        <template v-if="isLoading"> Deleting... </template>
        <template v-else>Confirm</template>
      </b-btn>
    </div>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "DeleteQuestionModal",
  methods: {
    ...mapActions("surveys", ["deleteQuestion"]),
    async onDelete() {
      if (this.questionProperties.questionId) {
        await this.deleteQuestion(this.questionProperties.questionId)
          .then(() => {
            this.$root.$emit("bv::hide::modal", "delete-question-modal");
            if (this.errors === null || Object.keys(this.errors).length === 0) this.$root.$emit("question-deleted");
          });
      } else {
        this.survey.pages.find(page => page.uuid === this.questionProperties.page_uuid).questions.splice(this.questionProperties.questionIndex, 1);
        this.$root.$emit("bv::hide::modal", "delete-question-modal");
      }
    },
  },
  computed: {
    ...mapGetters("surveys", ["errors", "isLoading", "survey", "questionProperties"])
  },
};
</script>

<style>
</style>